/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { QUICKSTART_TYPE } from '../../common/constants.tsx';
import type { State } from './types.tsx';

// These selectors are used by actions - we can't define them in ../index.tsx file because of circular dependencies

export const isJsmProjectSelector = (state: State): boolean =>
	state.projectState?.projectType === SERVICE_DESK_PROJECT;

export const getQuickstartTypeSelector = (
	state: State,
): 'jsw-onboarding-checklist' | 'jsm-business-checklist' => {
	if (isJsmProjectSelector(state)) {
		return QUICKSTART_TYPE.JSM_BUSINESS_QUICKSTART_KEY;
	}
	return QUICKSTART_TYPE.OLD_GLOBAL_QUICKSTART_KEY;
};
